import OrderCargoOrderChangeApprovalStatusRequest, {
  OrderCargoOrderChangeApprovalStatusRequestStatus,
} from "../../../../api/raily/order/cargo-order/change-approval-status/order-cargo-order-change-approval-status.request";
import OrderCargoOrderChangeApprovalStatusParams, {
  OrderCargoOrderChangeApprovalStatusParamsApprovalStatus,
} from "./order-cargo-order-change-approval-status-params";

const createStatus = (
  status: OrderCargoOrderChangeApprovalStatusParamsApprovalStatus,
): OrderCargoOrderChangeApprovalStatusRequestStatus => {
  switch (status) {
    case OrderCargoOrderChangeApprovalStatusParamsApprovalStatus.ACCEPTED:
      return OrderCargoOrderChangeApprovalStatusRequestStatus.ACCEPTED;
    case OrderCargoOrderChangeApprovalStatusParamsApprovalStatus.REJECTED:
      return OrderCargoOrderChangeApprovalStatusRequestStatus.REJECTED;
  }
};

const create = (
  params: OrderCargoOrderChangeApprovalStatusParams,
): OrderCargoOrderChangeApprovalStatusRequest => {
  return {
    orderUuid: params.orderUuid,
    status: createStatus(params.status),
  };
};

const orderCargoOrderChangeApprovalStatusParamsFactory = {
  create,
};

export default orderCargoOrderChangeApprovalStatusParamsFactory;
